import { render, staticRenderFns } from "./fhlfx.vue?vue&type=template&id=44285bcc&scoped=true"
import script from "./fhlfx.vue?vue&type=script&lang=js"
export * from "./fhlfx.vue?vue&type=script&lang=js"
import style0 from "./fhlfx.vue?vue&type=style&index=0&id=44285bcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44285bcc",
  null
  
)

export default component.exports